module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/testimonial-1-6b4382edbeecaaac83be80e3655d0afb.png";